export const reCaptchaSiteKey = "6LfUmdgaAAAAAJ3Ix9If-8xQXBrg_lFRgGDc8xf7";
